import { render, staticRenderFns } from "./TotalCoupon.vue?vue&type=template&id=12288e72&"
import script from "./TotalCoupon.vue?vue&type=script&lang=js&"
export * from "./TotalCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports